import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#2B2D42] text-white py-20">
      <div className="w-4/5 mx-auto">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-16">
            {/* Company Info */}
            <div>
              <h3 className="text-2xl font-light mb-6" style={{ fontFamily: 'Crimson Text, serif' }}>
                Vantage Commercial Advisory
              </h3>
              <p className="text-base text-white/70 leading-relaxed">
                Selective engagements across the Southeast United States
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-sm uppercase tracking-wider text-white/50 mb-6">Navigation</h4>
              <nav className="space-y-4">
                <Link to="/" className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  Home
                </Link>
                <Link to="/margin-integrity-review" className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  Margin Integrity Review
                </Link>
                <Link to="/our-approach" className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  Our Approach
                </Link>
                <Link to="/who-we-work-with" className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  Who We Work With
                </Link>
                <Link to="/about" className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  About
                </Link>
                <Link to="/contact" className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </nav>
            </div>

            {/* Contact CTA */}
            <div>
              <h4 className="text-sm uppercase tracking-wider text-white/50 mb-6">Get Started</h4>
              <p className="text-base text-white/70 leading-relaxed mb-6">
                Ready to identify hidden margin leakage?
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-3 text-base text-white hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Request a Free Confidential Discussion</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-12 border-t border-white/10">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              <p className="text-sm text-white/50">
                © {new Date().getFullYear()} Vantage Commercial Advisory. All rights reserved.
              </p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/50 hover:text-white/70 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
